import React, { useImperativeHandle, useRef, useEffect, forwardRef, useState } from "react";
import { Modal } from 'bootstrap';
import TapSelect from "../../../components/ui/TapSelect";
import Loader from "../../../components/ui/Loader/Loader";
import { BACKOFFICE_BASE_URL } from "../../../services/TapApiUrls";
import HttpAPICall from "../../../services/HttpAPICall";
import { useSelector } from "react-redux";

const AssetTypeSearchModal = forwardRef(({submitSearchFormProp}, ref) => {

    const assetTypeFormDataUrl  =   BACKOFFICE_BASE_URL + '/asset_type/form_data';
    const access_token          =   useSelector(state => state.auth.access_token);
    const modalElem             =   useRef(null);
    const searchModal           =   useRef(null);

    const [assetTypeSearchForm, setAssetTypeSearchForm] = useState({
        link_asset_type_name    :   '',
        search_section_ids      :   [],
    });

    const searchFormLabel   =   {
        link_asset_type_name    :   'Name : ',
        search_section_ids      :   'Sections : '
    };

    const [formLoading, setFormLoading] =   useState(false);   
    const [sectionList, setSectionListing]  =   useState([]);

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            searchModal.current.show();
        },
        clearSearchForm: () => {
            setAssetTypeSearchForm({
                link_asset_type_name    :   '',
                search_section_ids      :   [],
            });
        }
    }));

    useEffect(() => {
        if(sectionList.length <= 0) {
            getAddFormData();
        }
        modalElem.current = document.getElementById("assetID");
        searchModal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (searchModal.current) {
                searchModal.current.dispose();
            }
        };
    }, []);


     const getAddFormData = () => {
        setFormLoading(true);
        HttpAPICall.withAthorization('GET', assetTypeFormDataUrl, access_token, {}, {}, (resp) => {
                const respData = resp.data.sections;
                setSectionListing(respData.map(s => ({label : s.component, value: s.id})));
            }
        ).then(() =>  setFormLoading(false));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAssetTypeSearchForm(prev => ({ ...prev, [name]: value }));
    };

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(assetTypeSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {
            let label = searchFormLabel[key];
            let value = assetTypeSearchForm[key];
            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'link_asset_type_name') {
                        show_val = assetTypeSearchForm ? assetTypeSearchForm.link_asset_type_name : '';
                    }
                    if (key == 'search_section_ids') {

                        show_val = sectionList.filter(s => assetTypeSearchForm.search_section_ids.includes(s.value)).map(s => s.label).join(', ');
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        submitSearchFormProp(searchedElems, assetTypeSearchForm);
        searchModal.current.hide();
    };

    const searchModalClose = () => {
        searchModal.current && searchModal.current.hide();
    };

    const yesNoOptions = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' }
    ];

    return (
        <>
            <div className="modal fade" id={"assetID"} tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="employeeSearchModalLabel">Asset Type Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={searchModalClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form id="assetTypeSearchForm" onSubmit={submitSearchForm}>
                                <div className="modal-body">
                                    {formLoading ? <Loader />
                                        : <>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Name</label>
                                                <div className="col-sm-10">
                                                    <input
                                                        name="link_asset_type_name"
                                                        type="text"
                                                        value={assetTypeSearchForm.link_asset_type_name}
                                                        className="form-control"
                                                        autoComplete="off"
                                                        onChange={handleInputChange}
                                                        placeholder="Please enter Asset Type Name"
                                                        style={{ height: "30px", fontSize: "93%" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row my-3 align-items-center">
                                                <label className="col-sm-2 col-form-label col-form-label-sm">Sections</label>
                                                <div className="col-sm-10">
                                                    <TapSelect
                                                        options={sectionList}
                                                        changeEvent={(selectedOption) => {
                                                            if(selectedOption) {
                                                                setAssetTypeSearchForm(prev => ({ ...prev, search_section_ids: selectedOption.map(s => s.value)}));
                                                            }
                                                        }}
                                                        value={sectionList.filter(u => assetTypeSearchForm.search_section_ids.includes(u.value))}
                                                        isSearchable={true}
                                                        isMulti={true}
                                                        isClearable={true}
                                                        placeholder="Select Sections"
                                                        containerHeight="30px"
                                                        fontSize="93%"
                                                    />
                                                </div>
                                            </div>
                                        </>}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={searchModalClose} data-bs-dismiss="modal">Close</button>
                                    <button type="submit" disabled={formLoading} className="btn btn-primary">Search</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
});

export default AssetTypeSearchModal;
